import AppDataService from "./AppDataService";

export default class NotesService {
  // Get all order notes with pagination and filter
  static async getAllOrderNotes(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.orderId) queryParams.append('orderId', params.orderId);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.pageNumber) queryParams.append('pageNumber', params.pageNumber);
    
    const queryString = queryParams.toString();
    const url = queryString ? `order-notes?${queryString}` : 'order-notes';
    
    return await AppDataService.get(url);
  }

  // Get a specific note by ID
  static async getOrderNoteById(noteId) {
    return await AppDataService.get(`order-notes/${noteId}`);
  }

  // Create a new note for a specific order
  static async createOrderNote(orderId, noteData) {
    return await AppDataService.post(`order-notes/${orderId}`, noteData);
  }

  // Update an existing note by ID
  static async updateOrderNote(noteId, noteData) {
    return await AppDataService.patch(`order-notes/${noteId}`, noteData);
  }

  // Delete a note by ID
  static async deleteOrderNote(noteId) {
    return await AppDataService.delete(`order-notes/${noteId}`);
  }
}
